<template>
  <div class="flex flex-wrap col-12">
    <div
      class="flex pointer white-bg col-12 card-top"
      @click="handleClick(offer)"
    >
      <div class="flex flex-wrap col-12">
        <div class="flex flex-wrap items-center col-11 lg-col-11 md-col-11 sm-col-11">
          <div class="flex col-12 bold h4 items-center">
            {{ offer.name }}
          </div>
          <div v-if="offer.detail && offer.detail.lowest_price" class="flex col-12 h5 items-center">
            <span v-if="offer.detail.prices && offer.detail.prices.length > 1" class="mr1">À partir de</span>
            <span>{{ offer.detail?.lowest_price }} €</span>
          </div>
        </div>
        <div class="flex col-1 justify-end items-center">
          <div>
            <i
              class="h3n icon icon-angle-down-icon bold"
              :class="{ 'icon-angle-up-icon': isOpen }"
            ></i>
          </div>
        </div>
      </div>
    </div>
    <div :id="`#pt-${sectionId}`" class="flex flex-wrap col-12 overflow-hidden mt1 collapsible white-bg">
      <div :id="`#pt-content-${sectionId}`" class="flex flex-wrap col-12 content">
        <div v-if="offer.description" class="mb2">{{ offer.description }}</div>
        <TariffList :contact="contact" :offer="offer" />
      </div>
    </div>
  </div>
</template>

<script>
import TariffList from '../../components/tariffs/TariffList';

export default {
  components: { TariffList },
  props: {
    session: {
      type: Object,
      default: null
    },
    contact: {
      type: Object,
      default: null
    },
    offer: {
      type: Object,
      default: null
    }
  },
  data () {
    return { isOpen: false };
  },
  computed: {
    siteInfo () {
      return this.$store.state.siteInfo;
    },
    sectionId () {
      return this.siteInfo && this.siteInfo.is_internal_session ? this.offer.uuid : this.offer.horanet_product.horanet_product_code;
    },
    isSelected () {
      if (this.siteInfo && this.siteInfo.is_internal_session) {
        return this.$store.state.offerInfo?.uuid === this.offer.uuid;
      }
      return this.$store.state.offerInfo?.horanet_product.horanet_product_code === this.offer.horanet_product.horanet_product_code;
    }
  },
  mounted () {
    if (this.isSelected) {
      this.toggleCollapsible(this.sectionId, true);
    }
  },
  methods: {
    handleClick (offer) {
      const offerId = this.siteInfo && this.siteInfo.is_internal_session ? offer.uuid : offer.horanet_product.horanet_product_code;
      if (!this.isSelected) {
        let { cartItem } = this.$store.state;
        cartItem = {
          ...cartItem,
          details: {
            ...cartItem.details,
            sessionProRataAmount: offer.sessionProRataAmount,
            contremarque: offer.contremarque,
            sans_support: offer.sans_support,
            tda_info: offer.tda_info,
            first_purchase: offer.detail.first_purchase,
            horanet_product_name: this.siteInfo && this.siteInfo.is_internal_session ? offer.name : offer.horanet_product.name,
            horanet_product_code: this.siteInfo && this.siteInfo.is_internal_session ? offer.uuid : offer.horanet_product.horanet_product_code,
            horanet_product_reference: this.siteInfo && this.siteInfo.is_internal_session ? offer.uuid : offer.horanet_product.horanet_product_reference,
            inscription: offer.detail.inscription,
            pass: offer.detail.pass,
            recurring: offer.detail.recurring,
            stage: offer.detail.stage,
            stage1D: offer.detail.stage1D,
            license: offer.detail.license,
            reloadable: offer.detail.reloadable,
            reservation: offer.detail.reservation,
            unit_sales: offer.detail.unit_sales,
            product_type: offer.name,
            cancelation: offer.cancelation,
            offer_type: offer.offer_type,
            offerProductType: offer.productType,
            isClubCard: offer.detail.isClubCard,
            firstRecurringSession: offer.firstRecurringSession
          }
        };

        this.$store.commit('addCartItemParticipantTariff', {
          participant: this.contact,
          tariff: null
        });
        this.$store.commit('setOfferInfo', offer);
        this.$store.commit('setCartItem', { ...cartItem });
        this.toggleCollapsible(offerId, true);
      } else {
        this.toggleCollapsible(offerId);
      }
    },
    toggleCollapsible (id, forceOpen = false) {
      const element = document.getElementById(
        `#pt-${id}`
      );
      if (element) {
        if (this.isOpen && !forceOpen) {
          element.style.height = '0px';
        } else {
          const content = document.getElementById(
            `#pt-content-${id}`
          );
          element.style.height = `${content.offsetHeight}px`;
        }

        this.isOpen = forceOpen || !this.isOpen;
      } else {
        console.log(`Element with id #pt-${id} not found`);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.collapsible {
  height: 0;
  transition: all 0.3s linear;
}
.content {
  min-height: 40px;
}
</style>
